import { ArrowLeft } from "lucide-react";

interface PublicHeaderProps {
  title: string;
  subtitle?: string;
}

const PublicHeader = ({ title, subtitle }: PublicHeaderProps) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 py-4 shadow-sm">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between">
          {/* Logo a sinistra */}
          <div className="flex-shrink-0">
            <img
              src="/assets/images/dark_extended.png"
              alt="Place2Be Logo"
              className="w-32 h-8 object-contain"
            />
          </div>

          {/* Titolo al centro */}
          <div className="flex-1 text-center">
            <h1 className="text-[#030A14]">{title}</h1>
            {subtitle && (
              <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>

          {/* CTA a destra */}
          <div className="flex-shrink-0">
            <a 
              href="/#/login" 
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#030A14] text-white rounded-full hover:bg-[#0A1525] transition-colors font-medium"
            >
              <ArrowLeft className="w-4 h-4" />
              Torna al Login
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
